import { cn } from "@/lib/utils";

export function SignalChip({ children, className, variant = "default", icon }) {
  const variants = {
    default: "border-white/10 bg-white/[0.03] text-foreground/90",
    lime: "border-lime-500/20 bg-lime-500/[0.06] text-lime-400",
    cyan: "border-[#7AD7FF]/20 bg-[#7AD7FF]/[0.06] text-[#7AD7FF]",
    amber: "border-[#FFD38A]/20 bg-[#FFD38A]/[0.06] text-[#FFD38A]",
    danger: "border-[#FF6B6B]/20 bg-[#FF6B6B]/[0.06] text-[#FF6B6B]",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium font-mono uppercase tracking-wider",
        variants[variant],
        className,
      )}
    >
      {icon && <span className="text-[10px]">{icon}</span>}
      {children}
    </span>
  );
}
